import './skeleton.scss';

const Skeleton = ({ width, height, variant = 'text' }) => (
    <span
        className={`skeleton skeleton--${variant}`}
        style={{ width, height }}
    />
);

export default Skeleton;
